import { http } from "./config";
import authHeader from "./auth-header";

class PermissoesService {
  cadastrar_permissao(permissao) {
    return http.post("/ged/permissoes", permissao, { headers: authHeader() });
  }

  listar_permissoes_arquivo(arquivoId) {
    return http.get(`/ged/permissoes/${arquivoId}`, { headers: authHeader() });
  }

  excluir_permissao(id) {
    return http.delete(`/ged/permissoes/${id}`, { headers: authHeader() });
  }
}

export default new PermissoesService();
